import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles, THUMBNAIL_BORDER_HEIGHT, THUMBNAIL_HEIGHT } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { CustomShape, makeCustomThumbnailShape, Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { TextileHelper } from '~src/spacesPlatform/utils/TextileHelper';

import { ProjectTooltip } from './ProjectTooltip';

export const PROJECT_THUMBNAIL_HEIGHT = THUMBNAIL_HEIGHT + THUMBNAIL_BORDER_HEIGHT;

export class ProjectCard extends ContentCard {

  public render() {
    const {
      content, urls, hovered, selected, allowDragAndDrop, addContentFavorite, removeContentFavorite, inRecycleBinSpace
    } = this.props;
    /*
      Card does not navigate or show FavoriteToggle and PopOver when in Recycle bin space.
    */
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          navigateUrl={inRecycleBinSpace ? null : getContentUrlForItem(content, urls)}
          defaultImageUrl={getAssignedThumbnailImgPath(content.id)}
          thumbnailImageUrl={getThumbnailUrlFromDescription(content.description)}
          hovered={hovered}
          selected={selected}
          imageCoverBackground={true}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
          customHeight={PROJECT_THUMBNAIL_HEIGHT}
          customShape={ProjectCardShape}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          {!inRecycleBinSpace && <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.projectDetails()}
            />
          </span>
          }
          <span>
            {!inRecycleBinSpace && <FavoriteToggle isTabbable={true}
              isFavorite={content.favorite}
              itemName={content.name}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'project' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'project' })} />
            }
          </span>
          {this.renderActionsMenu()}
        </div>
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return ProjectTooltip;
  }
}

export function getThumbnailUrlFromDescription(description: string): string {
  const results = TextileHelper.TRAILING_IMAGE.exec(description);
  if (results) {
    return results[1];
  }
  return undefined;
}

export function getAssignedThumbnailImgPath(projectId: string): string {
  // there are three possible default thumbnails for projects
  const index = Number.parseInt(projectId, 10) % 3 + 1;
  const filename = `project-thumb-${index}.png`;
  return imgPath(filename);
}

const folderDrawPath = 'M2.5 0.5H183.9A4 4 0 0 1 187.2 2.2L198.8 18.8A4 4 0 0 0 202.1 20.5H297.5A2 2 0 0 1 299.5 22.5V183.5A2 2 0 0 1 297.5 185.5H2.5A2 2 0 0 1 0.5 183.5V2.5A2 2 0 0 1 2.5 0.5Z';
export const ProjectCardShape: CustomShape = makeCustomThumbnailShape(folderDrawPath, 'project-folder-clip-path');
